var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "time-up" }, [
    _c(
      "span",
      { staticClass: "title" },
      [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _vm._t("title")],
      2
    ),
    _c("span", { staticClass: "show-time" }, [
      _vm._v(
        "\n    " + _vm._s(_vm._f("format")(_vm.date, "HH:mm:ss SSS")) + "\n  "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c0bc0e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c0bc0e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/timer-up/index.vue
// module id = cXVd
// module chunks = 164